import { createContext, useContext } from 'react';

const OrderProductsContext = createContext([[], () => {}, () => {}, () => {}]);

export const OrderProductsProvider = OrderProductsContext.Provider;
export const useOrderProducts = () => useContext(OrderProductsContext);
